import type {
  FeedbackCreateRequest,
  FeedbackCreateResponse,
} from "@shared/contracts/api";
import { apiRequest } from "./client";

export async function submitFeedback(
  message: string,
): Promise<FeedbackCreateResponse> {
  return apiRequest<FeedbackCreateResponse>("/api/feedback", {
    method: "POST",
    body: {
      message,
    } satisfies FeedbackCreateRequest,
  });
}
